// @flow
import { getTeamUrl } from 'Common';
//import fetchEstimates from '../services/fetchEstimates'

export default () => async (dispatch: Function, getState: Function) => {

  const { project, selectedEstimateIds, selectedOrderIds } = getState().screens.ProjectView;

  let url

  if (selectedEstimateIds.length) {
    url = `${getTeamUrl(`projects/${project.id}/draft_job_sheet_pdf`, 'exports')}?estimate_ids=${selectedEstimateIds.join(',')}`
  } else {
    url = `${getTeamUrl(`projects/${project.id}/job_sheet_pdf`, 'exports')}?order_ids=${selectedOrderIds.join(',')}`
  }

  window.open(url);

  //dispatch(fetchEstimates())

}
